module.exports = "pegasus/assets/column-1-basic.png";